import React, { useState, useEffect, useRef } from 'react';
import './StatsCounter.scss';

const StatsCounter: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [counts, setCounts] = useState({ devices: 0, countries: 0, uptime: 0, recovered: 0 });
  const sectionRef = useRef<HTMLElement>(null);

  const stats = [
    { end: 15000, label: 'Devices Sold', suffix: '+', key: 'devices' },
    { end: 150, label: 'Countries', suffix: '+', key: 'countries' },
    { end: 99.9, label: 'Uptime', suffix: '%', key: 'uptime' },
    { end: 2500, label: 'Assets Recovered', suffix: '+', key: 'recovered' }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  useEffect(() => {
    if (!isVisible) return;

    stats.forEach(stat => {
      const duration = 2000;
      const steps = 60;
      const increment = stat.end / steps;
      let current = 0;

      const timer = setInterval(() => {
        current += increment;
        if (current >= stat.end) {
          current = stat.end;
          clearInterval(timer);
        }
        setCounts(prev => ({ ...prev, [stat.key]: current }));
      }, duration / steps);
    });
  }, [isVisible]);

  return (
    <section ref={sectionRef} className="stats-counter">
      <div className="container">
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <div className="stat-number">
                {stat.key === 'uptime' 
                  ? counts[stat.key as keyof typeof counts].toFixed(1)
                  : Math.floor(counts[stat.key as keyof typeof counts]).toLocaleString()}
                {stat.suffix}
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsCounter;
